import React, {FC, memo} from "react";
import {MobileSectionsSelectorProps} from "./MobileSectionsSelector-types";
import {Icon, HeadItem, Label, Root, Head, Body, IconWrap} from "./MobileSectionsSelector-styles";


const MobileSectionsSelector: FC<MobileSectionsSelectorProps> = memo((props) => {
    const {tabs, children, isDrawerActive, tabActive, onTabToggle, onSwipeHandlers} = props;

    return (
        <Root>
            <Head {...onSwipeHandlers}>
                {tabs.map((tab) => (
                    <HeadItem key={tab.id} onClick={() => onTabToggle(tab.id)}>
                        <IconWrap $isActive={isDrawerActive && tabActive === tab.id}>
                            <Icon as={tab.icon}/>
                        </IconWrap>

                        <Label>{tab.title}</Label>
                    </HeadItem>
                ))}

            </Head>

            <Body $isOpened={isDrawerActive}>
                {children}
            </Body>
        </Root>
    );
});

export default MobileSectionsSelector;
